import { render } from "./Kkp.vue?vue&type=template&id=23c3d4d1&scoped=true"
import script from "./Kkp.vue?vue&type=script&lang=js"
export * from "./Kkp.vue?vue&type=script&lang=js"

import "./Kkp.vue?vue&type=style&index=0&id=23c3d4d1&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3d4d1"]])

export default __exports__